
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "data-privacy-request-ui",
  currentProjectVersion: "static-1.6016",
  depVersions: {
  "data-privacy-request-ui": "static-1.6016",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10129",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8530",
  "hub-http-shared-msw-handlers": "static-1.10930",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11977",
  "I18n": "static-7.1711",
  "jasmine-runner": "static-1.6943",
  "quartz": "static-1.7686",
  "react-dlb": "static-1.96",
  "rpc-client-utils": "static-1.5160",
  "ui-components-test-utils": "static-1.6114",
  "UIComponents": "static-3.8923",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.100",
  "foundations-assets": "static-1.5378",
  "foundations-components": "static-1.8774",
  "foundations-components-test-utils": "static-1.6257",
  "foundations-theming": "static-1.4980",
  "hub-http": "static-1.6696",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1464",
  "quartz-core": "static-1.6905",
  "quartz-routing": "static-1.1116",
  "quartz-tracking": "static-1.1065",
  "quick-fetch": "static-1.4239",
  "raven": "static-3.5925",
  "react": "static-7.204",
  "react-rhumb": "static-1.17230",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11635",
  "usage-tracker-core": "static-1.7664",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3963",
  "quartz-webpack": "static-1.3910",
  "bend-plugin-quartz-routing": "static-1.764",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.94",
  "HeadJS": "static-2.826",
  "framer-motion": "static-1.85",
  "hs-test-utils-bend-plugin": "static-1.3641",
  "msw": "static-1.104",
  "msw-config": "static-1.32",
  "testing-library": "static-1.166",
  "ts-schema": "static-1.4403",
  "i18n-data": "static-1.236",
  "moment-timezone": "static-5.97",
  "react-utils": "static-2.5669",
  "StyleGuideUI": "static-3.519",
  "jasmine": "static-4.4797",
  "bend-plugin-chirp-manifest": "static-1.570",
  "chirp-fetch": "static-1.2395",
  "HubStyle": "static-2.12284",
  "ui-addon-draggable": "static-3.5240",
  "cssUtils": "static-1.1113",
  "hs-story-utils": "static-1.9919",
  "icons": "static-2.707",
  "react-create-root-preference": "static-1.108",
  "react-select-plus": "static-1.119",
  "react-virtualized": "static-2.113",
  "ui-images": "static-2.1281",
  "bend-plugin-foundations-components": "static-1.5043",
  "floating-ui": "static-1.69",
  "foundations-theming-specialty": "static-1.2696",
  "react-aria": "static-1.78",
  "tanstack-table": "static-1.67",
  "trellis-assets": "static-1.3128",
  "ui-fonts": "static-1.1239",
  "foundations-components-legacy": "static-1.1799",
  "bend-plugin-foundations-theming": "static-1.3463",
  "foundations-theming-base": "static-1.3965",
  "stylex": "static-1.47",
  "hs-locale-management": "static-1.411",
  "opentelemetry-fe-types": "static-1.281",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.909",
  "hubspotter-http": "static-1.4983",
  "mobile-manifest-mixins": "static-1.608",
  "module-federation": "static-1.40",
  "opentelemetry-fe": "static-1.656",
  "quartz-auth": "static-1.1361",
  "quartz-head": "static-1.1351",
  "quartz-i18n": "static-1.1361",
  "quartz-test": "static-1.1361",
  "trellis-components": "static-1.3147",
  "usage-tracker-container": "static-1.7804",
  "usage-tracker-session-replay": "static-1.5500",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.191",
  "web-vitals": "static-1.20",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3604",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.84",
  "sassPrefix": "static-1.378",
  "stylex-utils": "static-1.179",
  "trellis-theming": "static-1.1504",
  "opentelemetry-web": "static-1.24",
  "hubspotter-http-shared-msw-handlers": "static-1.10928",
  "base-ui": "static-1.30",
  "react-day-picker": "static-1.16",
  "tanstack-virtual": "static-1.44",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.6016",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10129",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8530",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10930",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11977",
  "I18n": "/I18n/static-7.1711",
  "jasmine-runner": "/jasmine-runner/static-1.6943",
  "quartz": "/quartz/static-1.7686",
  "react-dlb": "/react-dlb/static-1.96",
  "rpc-client-utils": "/rpc-client-utils/static-1.5160",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6114",
  "UIComponents": "/UIComponents/static-3.8923",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.100",
  "foundations-assets": "/foundations-assets/static-1.5378",
  "foundations-components": "/foundations-components/static-1.8774",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6257",
  "foundations-theming": "/foundations-theming/static-1.4980",
  "hub-http": "/hub-http/static-1.6696",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1464",
  "quartz-core": "/quartz-core/static-1.6905",
  "quartz-routing": "/quartz-routing/static-1.1116",
  "quartz-tracking": "/quartz-tracking/static-1.1065",
  "quick-fetch": "/quick-fetch/static-1.4239",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.204",
  "react-rhumb": "/react-rhumb/static-1.17230",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11635",
  "usage-tracker-core": "/usage-tracker-core/static-1.7664",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3963",
  "quartz-webpack": "/quartz-webpack/static-1.3910",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.764",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.94",
  "HeadJS": "/HeadJS/static-2.826",
  "framer-motion": "/framer-motion/static-1.85",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3641",
  "msw": "/msw/static-1.104",
  "msw-config": "/msw-config/static-1.32",
  "testing-library": "/testing-library/static-1.166",
  "ts-schema": "/ts-schema/static-1.4403",
  "i18n-data": "/i18n-data/static-1.236",
  "moment-timezone": "/moment-timezone/static-5.97",
  "react-utils": "/react-utils/static-2.5669",
  "StyleGuideUI": "/StyleGuideUI/static-3.519",
  "jasmine": "/jasmine/static-4.4797",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.570",
  "chirp-fetch": "/chirp-fetch/static-1.2395",
  "HubStyle": "/HubStyle/static-2.12284",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5240",
  "cssUtils": "/cssUtils/static-1.1113",
  "hs-story-utils": "/hs-story-utils/static-1.9919",
  "icons": "/icons/static-2.707",
  "react-create-root-preference": "/react-create-root-preference/static-1.108",
  "react-select-plus": "/react-select-plus/static-1.119",
  "react-virtualized": "/react-virtualized/static-2.113",
  "ui-images": "/ui-images/static-2.1281",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5043",
  "floating-ui": "/floating-ui/static-1.69",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2696",
  "react-aria": "/react-aria/static-1.78",
  "tanstack-table": "/tanstack-table/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.3128",
  "ui-fonts": "/ui-fonts/static-1.1239",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1799",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3463",
  "foundations-theming-base": "/foundations-theming-base/static-1.3965",
  "stylex": "/stylex/static-1.47",
  "hs-locale-management": "/hs-locale-management/static-1.411",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.281",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.909",
  "hubspotter-http": "/hubspotter-http/static-1.4983",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.608",
  "module-federation": "/module-federation/static-1.40",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.656",
  "quartz-auth": "/quartz-auth/static-1.1361",
  "quartz-head": "/quartz-head/static-1.1351",
  "quartz-i18n": "/quartz-i18n/static-1.1361",
  "quartz-test": "/quartz-test/static-1.1361",
  "trellis-components": "/trellis-components/static-1.3147",
  "usage-tracker-container": "/usage-tracker-container/static-1.7804",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5500",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.191",
  "web-vitals": "/web-vitals/static-1.20",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.84",
  "sassPrefix": "/sassPrefix/static-1.378",
  "stylex-utils": "/stylex-utils/static-1.179",
  "trellis-theming": "/trellis-theming/static-1.1504",
  "opentelemetry-web": "/opentelemetry-web/static-1.24",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10928",
  "base-ui": "/base-ui/static-1.30",
  "react-day-picker": "/react-day-picker/static-1.16",
  "tanstack-virtual": "/tanstack-virtual/static-1.44",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
